import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-chat',
  templateUrl: './chat.component.svg',
})
export class MedsafeChatComponent extends MedrecordIcon {
  viewHeight = 24;
  viewWidth = 24;
}
